import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const HIDDEN_PATHS = ['/interactive'];

const navLinks = [
  { label: 'HOME', path: '/' },
  { label: 'CAMPAIGN CONCEPT', path: '/campaign-concept' },
  { label: 'STOREFRONT', path: '/storefront' },
  { label: 'INTERACTIVE', path: '/interactive' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  if (HIDDEN_PATHS.includes(location.pathname)) return null;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
          scrolled ? 'bg-black/90 backdrop-blur-sm border-b border-white/5' : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between px-8 md:px-16 py-5">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/59cfd97b3dc3ca96c63739e63b4f628a.jpeg"
              alt="Gucci Beauty Logo"
              className="h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xs tracking-widest font-light transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#EADDCC]'
                    : 'text-[#EADDCC]/50 hover:text-[#EADDCC]'
                }`}
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-px bg-[#EADDCC] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-px bg-[#EADDCC] transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-px bg-[#EADDCC] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-black/98 flex flex-col items-center justify-center transition-all duration-700 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="flex flex-col items-center gap-10">
          {navLinks.map((link, i) => (
            <Link
              key={link.path}
              to={link.path}
              className="text-[#EADDCC] text-2xl tracking-widest font-light cursor-pointer hover:text-[#4D1815] transition-colors duration-300"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                transitionDelay: `${i * 80}ms`,
                opacity: menuOpen ? 1 : 0,
                transform: menuOpen ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.5s ease ${i * 80}ms, transform 0.5s ease ${i * 80}ms, color 0.3s ease`,
              }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
